module.exports = __webpack_public_path__ + "static/media/empty11_files_anim.10648536.svg";